import Image from "next/image";

import {
  FaGoogle,
  FaTwitter,
  FaFacebook,
  FaYoutube,
  FaTwitch,
  FaReddit,
  FaLink,
} from "react-icons/fa";

const getDomain = (link: string) => {
  if (!link) return;
  const m = link.match(/^https?:\/{2,}(.*?)(?:\/|\?|#|$)/);
  return m ? m[1] : "";
};
const returnAccountsIcon = (domain = "") => {
  switch (domain) {
    case "www.google.com":
      return <FaGoogle color="#db4437" />;
    case "twitter.com":
      return <FaTwitter color="#1da1f2" />;
    case "www.instagram.com":
      return (
        <div className="nextimg">
          <Image src="/instagram.png" alt="Instagram" width={20} height={20} />
        </div>
      );
    case "www.facebook.com":
      return <FaFacebook color="#3b5998" />;
    case "www.youtube.com":
      return <FaYoutube color="#ff0000" />;
    case "www.twitch.tv":
      return <FaTwitch color="#6441a4" />;
    case "www.reddit.com":
      return <FaReddit color="#ff4500" />;
    default:
      return <FaLink className="text-dark-900 dark:text-light-50" />;
  }
};

export const userLinkIcons = (links: string[]) => {
  const accountIcons = links.map((link, index) => {
    if (!link) return;
    return (
      <li key={index} className="text-xl">
        <a href={link} target="_blank" rel="noopener noreferrer nofollow">
          {returnAccountsIcon(getDomain(link))}
        </a>
      </li>
    );
  });
  return accountIcons.filter((i) => i);
};

const shareAccounts = ["Twitter", "Facebook"] as const;
type Account = typeof shareAccounts[keyof typeof shareAccounts];

const getShareUrl = (
  name: Account,
  articleUrl: string,
  articleTitle: string
) => {
  const url = encodeURIComponent(articleUrl);
  const title = encodeURIComponent(articleTitle);
  switch (name) {
    case "Twitter":
      return `https://twitter.com/share?url=${url}&text=${title}&hashtags=Boitorea`;
    case "Facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    default:
      return `https://twitter.com/share?url=${url}&text=${title}&hashtags=Boitorea`;
  }
};

export const returnIcon = (name: Account) => {
  switch (name) {
    case "Twitter":
      return <FaTwitter color="#1da1f2" />;
    case "Facebook":
      return <FaFacebook color="#3b5998" />;
    default:
      return <FaTwitter color="#1da1f2" />;
  }
};
export const shareBtns = (articleUrl: string, articleTitle: string) => {
  const shareIcons = shareAccounts.map((account, index) => {
    return (
      <li key={index}>
        <a
          href={getShareUrl(account, articleUrl, articleTitle)}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-xl"
          aria-label="この記事をシェアする"
        >
          {returnIcon(account)}
        </a>
      </li>
    );
  });
  return shareIcons;
};
